import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useController = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const tabValue = queryParams.get("tab") ?? "Activities";

  const [currentTab, setCurrentTab] = useState(tabValue);
  const [state] = useState(location.state);

  const handleChangeTab = (value: string) => {
    setCurrentTab(value);
    navigate(`${location.pathname}?tab=${value}`, {
      replace: true,
    });
  };

  return { currentTab, handleChangeTab, state };
};
